import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { track } from '@vercel/analytics';
import { useContentful } from './contentful-context';
import { sortBy } from './utils';
import './Pages/Why.css';

function ArrowIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M5 12h14M13 6l6 6-6 6" />
    </svg>
  );
}

function InterestCard({ profile }) {
  const isInvestor = profile.title.toLowerCase().includes('invest');
  const formPath = isInvestor
    ? `/contact/invest-in-us/${profile.hbsformid}`
    : `/contact/build-with-us/${profile.hbsformid}`;
  const tag = isInvestor ? 'Investors' : 'Builders & developers';
  const buttonLabel = profile.botton || 'Learn more';

  const handleClick = () => {
    track('interest_profile_selected', {
      profileType: isInvestor ? 'investor' : 'builder',
      profileTitle: profile.title,
    });
  };

  return (
    <div className={`ctacard${isInvestor ? '' : ' feat'}`}>
      <span className="tag">{tag}</span>
      <h3>{profile.title}</h3>
      <p>{profile.body}</p>
      <div className="act">
        <Link className="btn btn-primary lg" to={formPath} onClick={handleClick}>
          {buttonLabel} <ArrowIcon />
        </Link>
      </div>
    </div>
  );
}

function InterestProfiles() {
  const content = useContentful();
  const profiles = sortBy(content.profiles, 'order');

  if (!profiles.length) {
    return null;
  }

  return (
    <div className="why-system-page grid-bg interest-profiles-page">
      <Helmet>
        <title>Contact — Construx</title>
      </Helmet>

      <section className="sec cta interest-profiles-page__main">
        <div className="wrap">
          <div className="sechead center">
            <div className="kicker plain" style={{ justifyContent: 'center' }}>
              Contact
            </div>
            <h1 className="h2">
              Start a conversation <span className="rust">with Construx.</span>
            </h1>
            <p className="lede">
              Choose the path that fits — partner on the framing system as a builder or developer, or explore
              investment opportunities.
            </p>
          </div>

          <div className="ctagrid interest-profiles-page__grid">
            {profiles.map((profile) => (
              <InterestCard key={profile.hbsformid} profile={profile} />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default InterestProfiles;
